import { DEFAULT_REFERENCE_TYPE_NAMES } from '@ardoq/data-model';
import { PARENT_REF_TYPE_NAME } from '@ardoq/api-types';

export type MetamodelGraphElement =
  | { kind: 'node'; name: string }
  | {
      kind: 'edge';
      sourceType: string;
      referenceType: string;
      targetType: string;
    };

export const metamodelGraphElementToString = (
  element: MetamodelGraphElement
): string =>
  element.kind === 'node'
    ? `node:${encodeURIComponent(element.name)}`
    : `edge:${[element.sourceType, element.referenceType, element.targetType]
        .map(encodeURIComponent)
        .join(',')}`;

export const metamodelGraphElementFromString = (
  value: string
): MetamodelGraphElement => {
  const separatorIndex = value.indexOf(':');
  const payload = value.slice(separatorIndex + 1);
  if (value.slice(0, separatorIndex) === 'edge') {
    const [sourceType, referenceType, targetType] = payload
      .split(',')
      .map(decodeURIComponent);
    return { kind: 'edge', sourceType, referenceType, targetType };
  }
  return { kind: 'node', name: decodeURIComponent(payload) };
};

export const metamodelGraphElementName = (
  element: MetamodelGraphElement
): string => (element.kind === 'node' ? element.name : element.referenceType);

export const isImplicitReferenceType = (referenceType: string): boolean =>
  referenceType === DEFAULT_REFERENCE_TYPE_NAMES.implicit;

export const isParentReferenceType = (referenceType: string): boolean =>
  referenceType === PARENT_REF_TYPE_NAME;
